import * as i0 from '@angular/core';
import { Directive, HostBinding, Input, contentChildren, viewChild, inject, Renderer2, input, model, output, computed, signal, effect, Component } from '@angular/core';
import { DOCUMENT, NgStyle, NgClass } from '@angular/common';
import { NgxSwipeDetectorDirective } from '@digipay/ngx-swipe-detector';
import { NgxButtonComponent } from '@digipay/ngx-button';
const _c0 = ["ngxCarouselItemsContainer"];
const _c1 = ["ngxCarouselMainContainer"];
const _c2 = [[["", "ngxCarouselSlide", ""]]];
const _c3 = ["[ngxCarouselSlide]"];
const _c4 = a0 => ({
  padding: a0
});
const _c5 = a0 => ({
  cards: a0
});
const _c6 = (a0, a1) => ({
  "justify-content-space-between": a0,
  "justify-content-center": a1
});
const _c7 = a0 => ({
  active: a0
});
const _c8 = () => ({
  name: "arrow-left",
  type: "linear"
});
const _c9 = () => ({
  name: "arrow-right",
  type: "linear"
});
function NgxCarouselComponent_Conditional_5_Conditional_2_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 8);
  }
  if (rf & 2) {
    const dot_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c7, dot_r2 === ctx_r2.index()));
  }
}
function NgxCarouselComponent_Conditional_5_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵrepeaterCreate(1, NgxCarouselComponent_Conditional_5_Conditional_2_For_2_Template, 1, 3, "div", 8, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("dots radius-big d-flex flex-row gap-tiny surface-back " + ctx_r2.navigationDotsContainerClasses());
    i0.ɵɵproperty("ngClass", ctx_r2.disableNavigationDots() ? "surface-transparent" : "p-low");
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r2.dots());
  }
}
function NgxCarouselComponent_Conditional_5_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ngx-button", 10);
    i0.ɵɵlistener("clickHandler", function NgxCarouselComponent_Conditional_5_Conditional_3_Conditional_1_Template_ngx_button_clickHandler_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.handleNavigationBtnClick("PREV"));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵstyleMap("tinted-on-elevated");
    i0.ɵɵproperty("mode", ctx_r2.navigationButtonPrevText() !== "" ? "section" : "icon-only")("size", ctx_r2.navigationButtonSize())("leftIcon", i0.ɵɵpureFunction0(6, _c9));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.navigationButtonPrevText(), " ");
  }
}
function NgxCarouselComponent_Conditional_5_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, NgxCarouselComponent_Conditional_5_Conditional_3_Conditional_1_Template, 2, 7, "ngx-button", 9);
    i0.ɵɵelementStart(2, "ngx-button", 10);
    i0.ɵɵlistener("clickHandler", function NgxCarouselComponent_Conditional_5_Conditional_3_Template_ngx_button_clickHandler_2_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.handleNavigationBtnClick("NEXT"));
    });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(1, ctx_r2.index() !== 0 ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("mode", ctx_r2.navigationButtonNextText() !== "" ? "section" : "icon-only")("size", ctx_r2.navigationButtonSize())("leftIcon", i0.ɵɵpureFunction0(5, _c8));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.navigationButtonNextText(), " ");
  }
}
function NgxCarouselComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6, 2);
    i0.ɵɵtemplate(2, NgxCarouselComponent_Conditional_5_Conditional_2_Template, 3, 3, "div", 5)(3, NgxCarouselComponent_Conditional_5_Conditional_3_Template, 4, 6, "div", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("navigation-container p-medium d-flex flex-row radius-minus align-items-center " + ctx_r2.navigationContainerClasses());
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(5, _c6, ctx_r2.showDots() && ctx_r2.showNavigation() && !ctx_r2.onlyOneNavigation(), ctx_r2.onlyOneNavigation()));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(2, ctx_r2.showDots() && ctx_r2.dots().length > 0 ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(3, ctx_r2.showButtons() ? 3 : -1);
  }
}
let NgxCarouselSlideDirective = /*#__PURE__*/(() => {
  class NgxCarouselSlideDirective {
    get style() {
      return this.customStyle;
    }
    constructor(element) {
      this.element = element;
      this.isActive = false;
      this.isNext = false;
      this.isPrev = false;
      this.defaultClass = true;
      this.customStyle = {};
    }
    static {
      this.ɵfac = function NgxCarouselSlideDirective_Factory(t) {
        return new (t || NgxCarouselSlideDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: NgxCarouselSlideDirective,
        selectors: [["", "ngxCarouselSlide", ""]],
        hostVars: 10,
        hostBindings: function NgxCarouselSlideDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleMap(ctx.style);
            i0.ɵɵclassProp("active", ctx.isActive)("is-next", ctx.isNext)("is-prev", ctx.isPrev)("carousel-item", ctx.defaultClass);
          }
        },
        inputs: {
          customStyle: "customStyle"
        },
        standalone: true
      });
    }
  }
  return NgxCarouselSlideDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let lastId = 0;
function UniqueComponentId(prefix = 'dpx_id_') {
  lastId++;
  return `${prefix}${lastId}`;
}
function isEqual(value1, value2) {
  // Check if the values are strictly equal
  if (value1 === value2) {
    return true;
  }
  // Check for null and undefined
  if (value1 == null || value2 == null) {
    return false;
  }
  // Check for different types
  if (typeof value1 !== typeof value2) {
    return false;
  }
  // If both values are arrays, compare them element by element
  if (Array.isArray(value1) && Array.isArray(value2)) {
    if (value1.length !== value2.length) {
      return false;
    }
    for (let i = 0; i < value1.length; i++) {
      if (!isEqual(value1[i], value2[i])) {
        return false;
      }
    }
    return true;
  }
  // If both values are objects, compare their keys and values
  if (typeof value1 === 'object' && typeof value2 === 'object') {
    const keys1 = Object.keys(value1);
    const keys2 = Object.keys(value2);
    if (keys1.length !== keys2.length) {
      return false;
    }
    for (const key of keys1) {
      if (!isEqual(value1[key], value2[key])) {
        return false;
      }
    }
    return true;
  }
  // For all other types, consider them not equal if the above checks don't apply
  return false;
}
let NgxCarouselComponent = /*#__PURE__*/(() => {
  class NgxCarouselComponent {
    constructor() {
      this.slides = contentChildren(NgxCarouselSlideDirective);
      this.itemsContainer = viewChild.required('ngxCarouselItemsContainer');
      this.mainContainer = viewChild.required('ngxCarouselMainContainer');
      // Injections
      this.renderer = inject(Renderer2);
      this.document = inject(DOCUMENT);
      // Inputs
      this.visibleItemCount = input(1);
      this.numScroll = input(1);
      this.carouselPadding = input('');
      this.mode = input('SINGLE');
      this.mainContainerClasses = input('');
      this.swipeThreshold = input(30);
      this.fixedWidth = input(0);
      this.fixedGap = input(0);
      this.itemsContainerVerticalPadding = input(undefined);
      this.index = model(0);
      this.scaleAmount = input(0.7);
      this.isFixedWidth = input(false);
      this.isFixedGap = input(false);
      this.centerMode = input(true);
      this.disableScaling = input(false);
      this.showNavigation = input(true);
      this.showDots = input(true);
      this.showButtons = input(true);
      this.isSlideOverflowVisible = input(false);
      this.navigationContainerClasses = input('');
      this.navigationDotsContainerClasses = input('');
      this.disableNavigationDots = input(false);
      this.navigationButtonSize = input('medium');
      this.navigationButtonNextText = input('');
      this.navigationButtonPrevText = input('');
      this.scalingTransformOrigin = input('center bottom');
      this.changeStepThresholdPercentage = input(50, {
        transform: value => Math.min(90, Math.max(10, value))
      });
      this.enableAutoPlay = input(false);
      this.autoPlayDurationMillis = input(3000);
      this.autoPlayCounts = input(0); // 0 is infinite
      this.autoPlayRebootDurationMillis = input(10000);
      // Outputs
      this.navigationBtnClicked = output();
      this.isAnimationRunning = output();
      this.singleTapped = output();
      this.isSwiping = output();
      this.isDragging = false;
      this.currentWalkX = 0;
      this.lastLeft = 0;
      this.calculatedGap = 0;
      this.calculatedWidth = 0;
      this.wrappers = [];
      this.isSwipingVertically = false;
      this.transitionSteps = [];
      this.isAnimating = false;
      this.onlyOneNavigation = computed(() => this.showDots() !== this.showButtons());
      this.dots = signal([]);
      this.autoPlayExecutedCount = 0;
      effect(() => {
        if (this.index() !== undefined) {
          this.step(false);
          if (this.transitionSteps.length === 0) {
            this.calculateSteps();
          }
        }
        if (this.slides()) {
          const currentSlides = this.slides().slice();
          if (!this.previousSlides || !isEqual(currentSlides, this.previousSlides)) {
            this.previousSlides = currentSlides;
            this.createStyle();
            this.wrapSlides();
            this.calculateSteps();
            this.updateSlidesState();
            if (this.slides().length) {
              this.startAutoPlay();
            }
          }
        }
      }, {
        allowSignalWrites: true
      });
    }
    ngAfterContentInit() {
      this.id = UniqueComponentId();
    }
    startAutoPlay() {
      if (!this.enableAutoPlay()) {
        return;
      }
      if (this.autoPlayIntervalId) {
        return;
      }
      this.autoPlayIntervalId = setInterval(() => {
        this.index.update(v => v + 1);
        if (this.index() > this.slides().length - 1) {
          this.index.set(0);
          if (this.autoPlayCounts()) {
            this.autoPlayExecutedCount++;
            if (this.autoPlayExecutedCount >= this.autoPlayCounts()) {
              clearInterval(this.autoPlayIntervalId);
            }
          }
        }
      }, this.autoPlayDurationMillis());
    }
    rebootAutoPlay() {
      if (this.autoPlayIntervalId) {
        clearInterval(this.autoPlayIntervalId);
        this.autoPlayIntervalId = undefined;
      }
      if (!this.autoPlayRebootTimeoutId) {
        this.autoPlayRebootTimeoutId = setTimeout(() => {
          this.startAutoPlay();
        }, this.autoPlayRebootDurationMillis());
      }
    }
    createStyle() {
      if (this.mode() === 'SINGLE') {
        if (!this.carouselStyle) {
          this.carouselStyle = this.renderer.createElement('style');
          this.carouselStyle.type = 'text/css';
          this.renderer.appendChild(this.document.head, this.carouselStyle);
        }
        this.carouselStyle.innerHTML = `#${this.id} .carousel-item {
				flex: 1 0 ${100 / this.visibleItemCount()}%
			}`;
      }
    }
    wrapSlides() {
      this.dots.set([]);
      this.slides().forEach((slide, index) => {
        this.dots.update(v => [...v, index]);
        const wrapper = this.renderer.createElement('div');
        this.renderer.addClass(wrapper, 'slide-wrapper');
        this.renderer.setStyle(wrapper, 'transition', 'transform 0.5s ease-in-out');
        this.renderer.setStyle(wrapper, 'overflow', this.isSlideOverflowVisible() ? 'visible' : 'hidden');
        const parent = slide.element.nativeElement.parentNode;
        this.renderer.insertBefore(parent, wrapper, slide.element.nativeElement);
        this.renderer.appendChild(wrapper, slide.element.nativeElement);
        this.wrappers.push(wrapper);
      });
      this.calculateWidthAndGap();
    }
    calculateWidthAndGap() {
      const mainWidth = this.roundIt(this.mainContainer().nativeElement.getBoundingClientRect().width);
      // Just Fixed Width
      if (this.isFixedWidth() && !this.isFixedGap()) {
        this.calculatedGap = this.roundIt((mainWidth - this.visibleItemCount() * this.fixedWidth()) / this.visibleItemCount());
        this.calculatedWidth = this.fixedWidth();
      }
      // Just Fixed Gap
      if (this.isFixedGap() && !this.isFixedWidth()) {
        this.calculatedWidth = this.roundIt((mainWidth - this.visibleItemCount() * this.fixedGap()) / this.visibleItemCount());
        this.calculatedGap = this.fixedGap();
      }
      // Fixed Gap And Width
      if (this.isFixedGap() && this.isFixedWidth()) {
        this.calculatedWidth = this.fixedWidth();
        this.calculatedGap = this.fixedGap();
      }
      this.setWrappersWidthAndGap(this.calculatedWidth, this.calculatedGap);
      if (this.transitionSteps.length === 0) {
        this.calculateSteps();
      }
    }
    setWrappersWidthAndGap(width, gap) {
      if (!this.centerMode()) {
        if (this.itemsContainerVerticalPadding() !== undefined) {
          if (this.itemsContainerVerticalPadding() === 0) {
            this.itemsContainer().nativeElement.style.padding = '0';
          } else {
            this.itemsContainer().nativeElement.style.padding = `0 ${this.itemsContainerVerticalPadding()}px`;
          }
        } else {
          this.itemsContainer().nativeElement.style.padding = `0 ${this.calculatedGap}px`;
        }
      }
      const mainContainerWidth = this.wrappers.length * width + (this.wrappers.length + 1) * gap;
      this.itemsContainer().nativeElement.style.gap = gap + 'px';
      this.itemsContainer().nativeElement.style.width = mainContainerWidth + 'px';
      this.wrappers.forEach(wrapper => {
        this.renderer.setStyle(wrapper, 'min-width', width + 'px');
        this.renderer.setStyle(wrapper, 'max-width', width + 'px');
        this.renderer.setStyle(wrapper, 'display', 'flex');
        this.renderer.setStyle(wrapper, 'flex-direction', 'flex-row');
        this.renderer.setStyle(wrapper, 'justify-content', 'center');
      });
    }
    calculateSteps() {
      this.transitionSteps = [];
      const mainWidth = this.roundIt(this.mainContainer().nativeElement.getBoundingClientRect().width);
      const gap = this.calculatedGap;
      const slideWidth = this.calculatedWidth;
      const stepWidth = slideWidth + gap;
      let step0 = gap / 2;
      if (this.centerMode()) {
        if (this.visibleItemCount() % 2 === 0) {
          step0 = -slideWidth / 2;
        } else {
          step0 = -(mainWidth - slideWidth) / 2;
        }
      } else {
        step0 = 0;
      }
      this.slides().forEach((slide, index) => {
        this.transitionSteps.push(this.roundIt(step0 + index * stepWidth));
      });
      if (this.index() > 0) {
        this.updateActiveSlide();
      } else {
        this.translateItemsContainer(this.transitionSteps[0]);
      }
    }
    // Start the carousel movement
    onSwipeStart(e) {
      this.isDragging = true;
      this.rebootAutoPlay();
      this.currentWalkX = 0;
      this.itemsContainer().nativeElement.style.transition = 'none';
    }
    handleSwipingVertically(event) {
      this.isSwipingVertically = event;
    }
    // Carousel is on the move
    swiping(e) {
      if (!this.isDragging) {
        return;
      }
      if (!this.isSwipingVertically) {
        this.isSwiping.emit(true);
        this.currentWalkX = e.deltaX;
        this.itemsContainer().nativeElement.style.transform = `translateX(${this.currentWalkX + this.lastLeft}px)`;
      }
    }
    // Carousel move is ended
    onSwipeX() {
      if (this.isDragging) {
        this.isDragging = false;
        this.updateActiveSlide();
      }
    }
    onSwipeEnd() {
      this.isSwiping.emit(false);
    }
    updateActiveSlide(isDragging = true) {
      if (!this.transitionSteps.length) {
        return;
      }
      const translateAmount = this.calculateNearestTranslatePoint(isDragging ? this.currentWalkX + this.lastLeft + this.transitionSteps[0] : this.lastLeft + this.transitionSteps[0]);
      this.index.set(this.transitionSteps.indexOf(translateAmount));
      this.lastLeft = translateAmount;
      this.translateItemsContainer(translateAmount);
      this.updateSlidesState();
    }
    updateSlidesState() {
      this.slides().forEach((slide, index) => {
        switch (this.mode()) {
          // Apply custom styles based on the mode
          case 'SINGLE':
            slide.isActive = index === this.index();
            break;
          case 'CARD':
            slide.customStyle = {
              ...this.getCustomStyles(index),
              maxWidth: '100%'
            };
            break;
        }
      });
    }
    calculateNearestTranslatePoint(totalWalkX) {
      const length = this.transitionSteps.length;
      if (!length) {
        return 0;
      }
      let downIndex = 0;
      let upIndex = 1;
      const thresholdRatio = this.changeStepThresholdPercentage() / 100;
      // Calculate Up and Down in Array
      if (totalWalkX > this.transitionSteps[length - 1]) {
        upIndex = length - 1;
        downIndex = length - 2;
      } else {
        for (let i = 0; i < length; i++) {
          if (i < length - 1) {
            if (totalWalkX < this.transitionSteps[i]) {
              upIndex = i;
              downIndex = i - 1;
              break;
            }
          } else {
            upIndex = length - 1;
            downIndex = length - 2;
            break;
          }
        }
      }
      if (upIndex === 0) {
        downIndex = 0;
        upIndex = 1;
      }
      // Calculate the transition threshold based on the provided percentage
      const stepDistance = this.transitionSteps[upIndex] - this.transitionSteps[downIndex];
      const thresholdDistance = stepDistance * thresholdRatio;
      const downDistance = Math.abs(this.transitionSteps[downIndex] - totalWalkX);
      const upDistance = Math.abs(this.transitionSteps[upIndex] - totalWalkX);
      // Choose the nearest point based on the threshold distance
      const moveRight = this.currentWalkX > 0;
      return moveRight ? downDistance > thresholdDistance ? this.transitionSteps[upIndex] : this.transitionSteps[downIndex] : upDistance > thresholdDistance ? this.transitionSteps[downIndex] : this.transitionSteps[upIndex];
    }
    getCustomStyles(index) {
      if (this.mode() === 'CARD') {
        if (index === this.index()) {
          return {
            transform: 'scale(1)',
            transition: 'transform 0.5s ease-in-out',
            transformOrigin: this.scalingTransformOrigin()
          };
        } else if (index === this.index() - 1 || index === this.index() + 1) {
          return {
            transform: this.disableScaling() ? 'scale(1)' : `scale(${this.scaleAmount()})`,
            transition: 'transform 0.5s ease-in-out',
            transformOrigin: this.scalingTransformOrigin()
          };
        } else {
          return {
            transform: this.disableScaling() ? 'scale(1)' : `scale(${this.scaleAmount()})`,
            transition: 'transform 0.5s ease-in-out',
            transformOrigin: this.scalingTransformOrigin()
          };
        }
      } else {
        return {};
      }
    }
    handleNavigationBtnClick(direction) {
      if (direction === 'NEXT') {
        if (this.index() !== this.slides.length - 1) {
          this.index.update(v => v + 1);
        }
      } else if (direction === 'PREV') {
        if (this.index() !== 0) {
          this.index.update(v => v - 1);
        }
      }
      this.navigationBtnClicked.emit(direction);
      this.step(false);
    }
    step(isDragging = true) {
      this.lastLeft = this.roundIt(this.index() * (this.calculatedWidth + this.calculatedGap));
      this.updateActiveSlide(isDragging);
    }
    translateItemsContainer(amount) {
      amount = this.roundIt(amount);
      this.itemsContainer().nativeElement.style.transition = 'transform 0.5s ease-in-out';
      this.itemsContainer().nativeElement.style.transform = `translateX(${amount}px)`;
    }
    roundIt(value) {
      return Math.round(value * 10) / 10;
    }
    handleAnimationRunning(isRunning) {
      this.isAnimating = isRunning;
      this.isAnimationRunning.emit(isRunning);
    }
    handleSingleTap() {
      if (!this.isAnimating) {
        this.singleTapped.emit();
      }
    }
    ngOnDestroy() {
      if (this.autoPlayRebootTimeoutId) {
        clearTimeout(this.autoPlayRebootTimeoutId);
      }
      if (this.autoPlayIntervalId) {
        clearInterval(this.autoPlayIntervalId);
      }
    }
    static {
      this.ɵfac = function NgxCarouselComponent_Factory(t) {
        return new (t || NgxCarouselComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxCarouselComponent,
        selectors: [["ngx-carousel"]],
        contentQueries: function NgxCarouselComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuerySignal(dirIndex, ctx.slides, NgxCarouselSlideDirective, 4);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        viewQuery: function NgxCarouselComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.itemsContainer, _c0, 5);
            i0.ɵɵviewQuerySignal(ctx.mainContainer, _c1, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance(2);
          }
        },
        inputs: {
          visibleItemCount: [i0.ɵɵInputFlags.SignalBased, "visibleItemCount"],
          numScroll: [i0.ɵɵInputFlags.SignalBased, "numScroll"],
          carouselPadding: [i0.ɵɵInputFlags.SignalBased, "carouselPadding"],
          mode: [i0.ɵɵInputFlags.SignalBased, "mode"],
          mainContainerClasses: [i0.ɵɵInputFlags.SignalBased, "mainContainerClasses"],
          swipeThreshold: [i0.ɵɵInputFlags.SignalBased, "swipeThreshold"],
          fixedWidth: [i0.ɵɵInputFlags.SignalBased, "fixedWidth"],
          fixedGap: [i0.ɵɵInputFlags.SignalBased, "fixedGap"],
          itemsContainerVerticalPadding: [i0.ɵɵInputFlags.SignalBased, "itemsContainerVerticalPadding"],
          index: [i0.ɵɵInputFlags.SignalBased, "index"],
          scaleAmount: [i0.ɵɵInputFlags.SignalBased, "scaleAmount"],
          isFixedWidth: [i0.ɵɵInputFlags.SignalBased, "isFixedWidth"],
          isFixedGap: [i0.ɵɵInputFlags.SignalBased, "isFixedGap"],
          centerMode: [i0.ɵɵInputFlags.SignalBased, "centerMode"],
          disableScaling: [i0.ɵɵInputFlags.SignalBased, "disableScaling"],
          showNavigation: [i0.ɵɵInputFlags.SignalBased, "showNavigation"],
          showDots: [i0.ɵɵInputFlags.SignalBased, "showDots"],
          showButtons: [i0.ɵɵInputFlags.SignalBased, "showButtons"],
          isSlideOverflowVisible: [i0.ɵɵInputFlags.SignalBased, "isSlideOverflowVisible"],
          navigationContainerClasses: [i0.ɵɵInputFlags.SignalBased, "navigationContainerClasses"],
          navigationDotsContainerClasses: [i0.ɵɵInputFlags.SignalBased, "navigationDotsContainerClasses"],
          disableNavigationDots: [i0.ɵɵInputFlags.SignalBased, "disableNavigationDots"],
          navigationButtonSize: [i0.ɵɵInputFlags.SignalBased, "navigationButtonSize"],
          navigationButtonNextText: [i0.ɵɵInputFlags.SignalBased, "navigationButtonNextText"],
          navigationButtonPrevText: [i0.ɵɵInputFlags.SignalBased, "navigationButtonPrevText"],
          scalingTransformOrigin: [i0.ɵɵInputFlags.SignalBased, "scalingTransformOrigin"],
          changeStepThresholdPercentage: [i0.ɵɵInputFlags.SignalBased, "changeStepThresholdPercentage"],
          enableAutoPlay: [i0.ɵɵInputFlags.SignalBased, "enableAutoPlay"],
          autoPlayDurationMillis: [i0.ɵɵInputFlags.SignalBased, "autoPlayDurationMillis"],
          autoPlayCounts: [i0.ɵɵInputFlags.SignalBased, "autoPlayCounts"],
          autoPlayRebootDurationMillis: [i0.ɵɵInputFlags.SignalBased, "autoPlayRebootDurationMillis"]
        },
        outputs: {
          index: "indexChange",
          navigationBtnClicked: "navigationBtnClicked",
          isAnimationRunning: "isAnimationRunning",
          singleTapped: "singleTapped",
          isSwiping: "isSwiping"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c3,
        decls: 6,
        vars: 12,
        consts: [["ngxCarouselMainContainer", ""], ["ngxCarouselItemsContainer", ""], ["navigationContainer", ""], [3, "ngStyle"], ["ngxSwipeDetector", "", 1, "items-container", "d-flex", "flex-rows", "justify-center", 3, "transitionstart", "transitionend", "swipeStart", "swiping", "isSwipingVertically", "singleTap", "swipedX", "swipeEnd", "ngClass", "axisToLockOn", "swipeThreshold"], [3, "class", "ngClass"], [3, "ngClass"], [1, "buttons", "d-flex", "flex-row", "gap-medium"], [1, "dot", "radius-giant", 3, "ngClass"], [3, "mode", "style", "size", "leftIcon"], [3, "clickHandler", "mode", "size", "leftIcon"]],
        template: function NgxCarouselComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef(_c2);
            i0.ɵɵelementStart(0, "div", 3, 0)(2, "div", 4, 1);
            i0.ɵɵlistener("transitionstart", function NgxCarouselComponent_Template_div_transitionstart_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleAnimationRunning(true));
            })("transitionend", function NgxCarouselComponent_Template_div_transitionend_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleAnimationRunning(false));
            })("swipeStart", function NgxCarouselComponent_Template_div_swipeStart_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onSwipeStart($event));
            })("swiping", function NgxCarouselComponent_Template_div_swiping_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.swiping($event));
            })("isSwipingVertically", function NgxCarouselComponent_Template_div_isSwipingVertically_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleSwipingVertically($event));
            })("singleTap", function NgxCarouselComponent_Template_div_singleTap_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleSingleTap());
            })("swipedX", function NgxCarouselComponent_Template_div_swipedX_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onSwipeX());
            })("swipeEnd", function NgxCarouselComponent_Template_div_swipeEnd_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onSwipeEnd());
            });
            i0.ɵɵprojection(4);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, NgxCarouselComponent_Conditional_5_Template, 4, 8, "div", 5);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassMap("carousel d-flex flex-column " + ctx.mainContainerClasses());
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(8, _c4, ctx.carouselPadding()));
            i0.ɵɵattribute("id", ctx.id);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c5, ctx.mode() === "CARD"))("axisToLockOn", "X")("swipeThreshold", ctx.swipeThreshold());
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(5, ctx.showNavigation() ? 5 : -1);
          }
        },
        dependencies: [NgStyle, NgClass, NgxSwipeDetectorDirective, NgxButtonComponent],
        styles: ["[_ngcontent-%COMP%]:root{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root{--base-font-feature-settings: \"ss01\" on, \"liga\" off, \"clig\" off}[_nghost-%COMP%]{width:100%;display:block}.carousel[_ngcontent-%COMP%]{width:100%;overflow:hidden}.carousel-inner[_ngcontent-%COMP%]{display:flex;transition:transform .5s ease-in-out}.items-container[_ngcontent-%COMP%]{position:relative;flex:1;width:100%;border:none;cursor:pointer;overflow:visible}.items-container[_ngcontent-%COMP%]   .carousel-item[_ngcontent-%COMP%]{transition:transform .5s ease-in-out,width .5s ease-in-out,height .5s ease-in-out}.items-container.cards.active[_ngcontent-%COMP%]{transform:scale(1.2)}.items-container.cards.is-next[_ngcontent-%COMP%], .items-container.cards.is-prev[_ngcontent-%COMP%]{transform:scale(.8)}.navigation-container[_ngcontent-%COMP%]   .dots[_ngcontent-%COMP%]   .dot[_ngcontent-%COMP%]{width:6px;height:6px;background:var(--onelevated-shade-80);transition:width .5s ease-out,background-color .5s ease-in}.navigation-container[_ngcontent-%COMP%]   .dots[_ngcontent-%COMP%]   .dot.active[_ngcontent-%COMP%]{width:14px;background:var(--onback-shade-20)}.navigation-container[_ngcontent-%COMP%]   .buttons[_ngcontent-%COMP%]   .button.prev[_ngcontent-%COMP%]{background:#e8eff9;color:#1159fc}.navigation-container[_ngcontent-%COMP%]   .buttons[_ngcontent-%COMP%]   .button.next[_ngcontent-%COMP%]{background:#000431;color:#fff}.carousel-control[_ngcontent-%COMP%]{justify-content:center;padding:8px}.prev[_ngcontent-%COMP%]{border:none;background:none;left:10px}.next[_ngcontent-%COMP%]{border:none;background:none;right:10px}"]
      });
    }
  }
  return NgxCarouselComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-carousel
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxCarouselComponent, NgxCarouselSlideDirective };
